import { render, staticRenderFns } from "./MetadataTag.vue?vue&type=template&id=1aa1c25e&"
import script from "./MetadataTag.vue?vue&type=script&lang=js&"
export * from "./MetadataTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports